import { Preferences } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { useAskBluejApiContext } from '../api/context';

export function useUserPreferencesQuery() {
  const { api } = useAskBluejApiContext();

  return useQuery({
    queryKey: ['preferences'],
    queryFn: async (): Promise<Preferences> => {
      const { preferences } = await api.getUserPreferences();
      const preferredTopic = preferences?.preferredTopic;
      const preferredFollowUpOption = preferences?.preferredFollowUpOption;
      const preferredThemeOption = preferences?.preferredThemeOption ?? 'system';
      const preferredLanguage = preferences?.preferredLanguage;
      const preferredWebSearchOption = preferences?.preferredWebSearchOption;
      if (!preferredTopic) {
        throw new Error('Unable to get user\'s preferred topic.');
      }

      return {
        preferredTopic,
        preferredFollowUpOption,
        preferredThemeOption,
        preferredLanguage,
        preferredWebSearchOption
      }
    },
    staleTime: Infinity,
    gcTime: Infinity
  })
}
